module.exports = __webpack_public_path__ + "static/main-227b34c46ccdec994037743072b26ca6.mp4";